import { post, postJson, get,put,deleteApi } from '../axios'

// const RESOURCE_BASE_PATH = '/tbPhoneBinding';

//查询素材列表
export const getCardFileList = p => get(`/sms-card-file/page`, p);

//查询可用素材列表
export const getCardValidFileList = p => get(`/sms-card-file/list`, p);

//保存、提交素材接口
export const saveCardFile = p => postJson(`/sms-card-file/save`, p);

//删除素材接口
export const deleteCardFile = id => deleteApi(`/sms-card-file/delete/${id}`);


//查询卡片列表
export const getCardList = p => get(`/sms-card-template/page`, p);

//查询可用卡片列表
export const getCardValidList = p => get(`/sms-card-template/list`, p);

//保存、提交卡片接口
export const saveCard = p => postJson(`/sms-card-template/save`, p);

//删除卡片接口
export const deleteCard = id => deleteApi(`/sms-card-template/delete/${id}`);

export const getCardDetail = id => get(`/sms-card-template/detail/${id}`);

export const getCardPreview = id => get(`/sms/card/preview/${id}`);